import getReduxSelector from 'modules/redux/selectors/get'
import {
  PRODUCTS_KEY,
  PRODUCTS_PATH
} from 'modules/product/redux/constants'

const getSelectedUseItWithVariantIdProductSelect = state => {
  const path = PRODUCTS_PATH[PRODUCTS_KEY.SELECTED_PERFECT_YOUR_LOOK_VARIANT_ID]
  return getReduxSelector(path)(state)
}

export default getSelectedUseItWithVariantIdProductSelect
